import Map from './Map';
export {Map};
export default Map;
